import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReportErrorModalLine } from './ReportErrorModalLine';
import {
  ModalScrollableHeader,
  ModalScrollableContainer,
} from '../../../components/modal';
import { UserContextType } from '../../../user/user.types';
import { WithModalProps } from '../../../components/modal/withModal';

type Props = {
  isOpen: boolean;
  loggedIn: UserContextType['loggedIn'];
  verified: boolean;
  lawyerName: string;
  lawyerId: string;
  onRequestClose: () => void;
  openModal: WithModalProps['openModal'];
};

export const ReportErrorModal: FC<Props> = ({
  isOpen = false,
  onRequestClose = () => {},
  loggedIn,
  verified,
  lawyerName,
  lawyerId,
  openModal,
}) => {
  const commonProps = {
    closeParentModal: onRequestClose,
    loggedIn,
    verified,
    lawyerName,
    lawyerId,
    openModal,
  };
  return (
    <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
      <ModalScrollableHeader
        title="Signaler une erreur"
        onClose={onRequestClose}
      />
      <ReportErrorModalLine
        border
        title={
          <FormattedMessage id="entity/expertises/ReportErrorModal.tsx/1" />
        }
        subtitle={
          <FormattedMessage id="entity/expertises/ReportErrorModal.tsx/2" />
        }
        url="https://doctrine.typeform.com/to/KKsJvP"
        {...commonProps}
      />
      <ReportErrorModalLine
        border
        title={
          <FormattedMessage id="entity/expertises/ReportErrorModal.tsx/3" />
        }
        subtitle={
          <FormattedMessage id="entity/expertises/ReportErrorModal.tsx/4" />
        }
        url="https://doctrine.typeform.com/to/KjW5FS"
        {...commonProps}
      />
      <ReportErrorModalLine
        title={
          <FormattedMessage id="entity/expertises/ReportErrorModal.tsx/5" />
        }
        subtitle={
          <FormattedMessage id="entity/expertises/ReportErrorModal.tsx/6" />
        }
        url="https://doctrine.typeform.com/to/E2UF1K"
        {...commonProps}
      />
    </ModalScrollableContainer>
  );
};
